import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
var hasOwnProperty = Object.prototype.hasOwnProperty;
/**
 * @param {...function} fns
 * @returns {function}
 */

export function compose() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return fns.reduce(function (composed, fn) {
    return function () {
      return composed(fn.apply(void 0, arguments));
    };
  });
}
/**
 * @param {string} name
 * @param {string} namespace
 * @returns {string}
 */

export function simpleActionTypeFactory(name, namespace) {
  return "".concat(namespace !== undefined ? "".concat(namespace, "/") : '').concat(name);
}
/**
 * @param {string} actionType
 * @returns {function}
 */

export function fluxStandardActionFactory(actionType) {
  /**
   * @param {any} payload
   * @param {boolean} error
   * @param {any} meta
   * @returns {object}
   */
  function action(payload, error, meta) {
    return _objectSpread({
      type: actionType,
      payload: payload
    }, error ? {
      error: true
    } : {}, meta !== undefined ? {
      meta: meta
    } : {});
  }
  /**
   * @param {any} meta
   * @returns {object}
   */


  function pending(meta) {
    return action(undefined, undefined, _objectSpread({}, meta, {
      pending: true
    }));
  }
  /**
   * @param {Error} err
   * @param {any} meta
   * @returns {object}
   */


  function error(err, meta) {
    return action(err, true, meta);
  }

  action.pending = pending;
  action.error = error;
  return action;
}
/**
 * @param {function} next
 * @returns {function}
 */

export function fluxStandardActionHandleEnhancer(next) {
  return function (state, action) {
    var payload = action.payload,
        error = action.error,
        _action$meta = action.meta;
    _action$meta = _action$meta === void 0 ? {} : _action$meta;
    var pending = _action$meta.pending;

    if (pending || error) {
      var usePending = state.pending !== undefined;
      var useError = state.error !== undefined;

      if (usePending || useError) {
        return pending ? _objectSpread({}, state, usePending ? {
          pending: true
        } : {}, useError ? {
          error: null
        } : {}) : _objectSpread({}, state, usePending ? {
          pending: false
        } : {}, useError ? {
          error: payload
        } : {});
      }

      return state;
    }

    return next(state, action);
  };
}
/**
 * @param {function} actionTypeFactory
 * @param {function} actionFactory
 * @returns {function}
 */

export function createReducerCreator(actionTypeFactory, actionFactory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var namespace = options.namespace,
        initialState = options.initialState,
        _options$handles = options.handles,
        handles = _options$handles === void 0 ? {} : _options$handles,
        actionEnhancer = options.actionEnhancer,
        handleEnhancer = options.handleEnhancer;
    var _handles = {};
    var _actions = {};
    /**
     * @param {any} state
     * @param {object} action
     * @returns {any}
     */

    function reducer() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
      var action = arguments.length > 1 ? arguments[1] : undefined;
      var handle = _handles[action.type];
      return handle ? handle(state, action) : state;
    }

    Object.defineProperty(reducer, 'namespace', {
      configurable: false,
      enumerable: true,
      get: function get() {
        return namespace;
      }
    });
    Object.defineProperty(reducer, 'initialState', {
      configurable: false,
      enumerable: true,
      get: function get() {
        return initialState;
      }
    });
    Object.defineProperty(reducer, 'handles', {
      configurable: false,
      enumerable: true,
      get: function get() {
        return _handles;
      }
    });
    Object.defineProperty(reducer, 'actions', {
      configurable: false,
      enumerable: true,
      get: function get() {
        return _actions;
      }
    });
    Object.entries(handles).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          name = _ref2[0],
          handle = _ref2[1];

      var actionType = actionTypeFactory(name, namespace);
      var action = actionFactory(actionType);
      action.actionName = name;
      action.actionType = actionType;
      /* eslint-disable no-param-reassign */

      handle.actionName = name;
      handle.actionType = actionType;
      /* eslint-enable no-param-reassign */

      var enhancedAction = actionEnhancer ? actionEnhancer(action) : action;
      var enhancedHandle = handleEnhancer ? handleEnhancer(handle) : handle;

      if (enhancedAction !== action) {
        Object.keys(action).forEach(function (key) {
          if (!hasOwnProperty.call(enhancedAction, key)) {
            enhancedAction[key] = action[key];
          }
        });
      }

      if (enhancedHandle !== handle) {
        Object.keys(handle).forEach(function (key) {
          if (!hasOwnProperty.call(enhancedHandle, key)) {
            enhancedHandle[key] = handle[key];
          }
        });
      }

      _actions[name] = enhancedAction;
      _handles[actionType] = enhancedHandle;
    });
    return reducer;
  };
}
/**
 * @function
 * @param {any} state
 * @param {object} action
 * @returns {any}
 */

export var createReducer = createReducerCreator(simpleActionTypeFactory, fluxStandardActionFactory);